import { FONT, FONT_TYPE } from '@tornado-rdk/typography';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { CallToAction as CallToActionPrimary } from '../../../callToAction/primary/callToAction.component';
import { CallToAction as CallToActionSecondary } from '../../../callToAction/secondary/callToAction.component';
import { MyListButtonSecondary } from '../../../myListCallToAction/myListCallToAction.component';
import { BORDER_WIDTH } from '../../../utils/focus';

export const SHOW_SERVICE_ICON = false;

export const SHOW_HIGHLIGHT = true;

export const SHOW_EXTRA_HIGHLIGHT = true;

export const SHOW_DETAILS = false;

export const SHOW_CONTENT_ADVISORY = false;

export const SHOW_BOTTOM_ROW = false;

export const EXTRA_TITLE_FONT = FONT.PARIS_3;

export const EXTRA_TITLE_FONT_TYPE = FONT_TYPE.MAIN;

export const DESCRIPTION_FONT = FONT.OTTAWA_2;

export const CTA_MARGIN_BOTTOM = {
  [HD]: 32,
  [FULL_HD]: 40,
};

export const CTA_BUTTON_MARGIN_RIGHT = {
  [HD]: 12 + BORDER_WIDTH[HD],
  [FULL_HD]: 16 + BORDER_WIDTH[FULL_HD],
};

export const BUTTON_TYPES = {
  PLAY_BUTTON: CallToActionPrimary,
  MY_LIST_BUTTON: MyListButtonSecondary,
  INFO_BUTTON: CallToActionSecondary,
  TRAILER_BUTTON: CallToActionSecondary,
};

export const INFO_ICON = { name: 'InfoLight', type: 'icon' };

export const TRAILER_ICON = { name: 'Trailer', type: 'icon' };
